/** @format */

import { CommonModule } from '@angular/common';
import {
	ComponentFactory,
	ComponentFactoryResolver,
	NgModule,
	NO_ERRORS_SCHEMA
} from '@angular/core';
import { PricedPackageComponent } from './priced-package.component';

@NgModule({
	imports: [CommonModule],
	declarations: [PricedPackageComponent],
	exports: [PricedPackageComponent],
	schemas: [NO_ERRORS_SCHEMA],
	bootstrap: [PricedPackageComponent]
})
export class PricedPackageModule {
	constructor(private resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<PricedPackageComponent> {
		return this.resolver.resolveComponentFactory(PricedPackageComponent);
	}
}
